import { render, staticRenderFns } from "./SinistroPrincipal.vue?vue&type=template&id=9adb7ae8&"
import script from "./SinistroPrincipal.vue?vue&type=script&lang=js&"
export * from "./SinistroPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports